import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './BannersList.css';
import { connect } from 'react-redux';
import { HOST } from '../../constants/Fetch'
import Preloader from '../Preloader';
import ErrorMessage from '../ErrorMessage';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadBanners } from '../../actions/BannersActions';

// IE detect
let isIE = false;
if (typeof(document) !== 'undefined') {
  isIE = false || !!document.documentMode;
}

const BannerItem = props => (
  <a
    href={props.banner.link}
    className={`bannersList__item ${props.count && props.count >= 2 && 'col col--6 colVertTablet--12'}`}
    style={{ backgroundImage:  props.vertical ? `url(${props.banner.image_vertical && HOST + props.banner.image_vertical})` : `url(${props.banner.image_horizontal && HOST + props.banner.image_horizontal})` }}
  >
    <div className="bannersList__itemInner">
      <span className="bannersList__itemName">{props.banner.name}</span>
      <span className="bannersList__itemText" dangerouslySetInnerHTML={{ __html: props.banner.text }} />
    </div>
  </a>
);

function shuffleArray(array) {
  let i = array.length - 1;
  for (; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

class BannersList extends Component {
  static requestData(store) {
    return requestAll([loadBanners], store);
  }

  static contextTypes = {
    width: PropTypes.number
  };

  componentDidMount() {
    this.props.actions.loadBanners();
  }

  render() {
    const shuffled = shuffleArray(this.props.banners);

    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }
    return (
      [
        (shuffled && shuffled.length > 0) &&
        <div
          key={`bannersList`}
          className={`bannersList ${isIE ? 'bannersList--table' : ''} ${((this.props.vertical  && this.context.width > 1050) || this.context.width <= 400) ? ' bannersList--tight' : ''} ${(this.props.count && this.props.count >= 2) ? ' row' : ''}`}
        >
          {
            shuffled.slice(0, this.props.count ? this.props.count : 1).map((banner, index) =>
              <BannerItem
                banner={banner}
                vertical={((this.props.vertical  && this.context.width > 1050) || this.context.width <= 400) && true}
                count={this.props.count}
                key={`bannersList__item-${index}`}
              />
            )
          }
        </div>
      ]
    )
  }
}

const mapStateToProps = (state) => {
  return {
      banners: state.banners.list,
      hasErrored: state.banners.hasErrored,
      isLoading: state.banners.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadBanners }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BannersList));



// WEBPACK FOOTER //
// ./src/components/BannersList/index.js